<template>
  <div
    class="bto-sb-widget bto-sb-widget-livestreaming bto-sb-horse-livestreaming"
    v-if="continousStreamingSis">
    <div class="bto-sb-widget-title">
      <h3>{{ t("Widget.VideoStreaming") }}</h3>
    </div>
    <template v-if="userLoggedIn()">
      <empty-state v-if="loading" :message="t('Mobile.LoadingMore')" :icon-class="loadingSpinner" />
      <div class="bto-sb-widget-content" v-if="!loading && hasTournaments">
        <livestream-component
          :streamId="streamId"
          :key="streamId"
          :isOnlyVideo="true"
          :providerId="providerId"
          @streamLoadError="livePlayerLoadError" />
      </div>
      <inline-message
        v-else-if="!loading && !hasTournaments"
        type="info"
        :message="t('Public.NoEventsAvailable')" />
    </template>
    <inline-message v-else type="warning" :message="t('Mobile.LoginFirst')" />
  </div>
</template>

<script>
  import { getStreamingMatches } from './service-video-streaming';
  import LivestreamComponent from '../../common/match/livestream-component.vue';
  import { ICON_CLASS, EmptyState } from '../../shared/empty-state';
  import { STREAM_PROVIDERS } from '../../../models/livestream/livestream.const';
  import { userLoggedIn } from '@bto-services/user';

  export default {
    name: 'VideoStreaming',
    data() {
      return {
        livePlayerFailed: false,
        loading: false,
        providerId: STREAM_PROVIDERS.SIS,
        hasTournaments: false,
        streamId: '',
        loadingSpinner: ICON_CLASS.LOADING,
      };
    },
    props: {
      continousStreamingSis: {
        type: Boolean,
        default: true,
        label: 'Use continous streaming',
        description: 'Flag whether to use SIS continous streaming (Horse Racing & Grayhounds)',
      },
      /** TODO:
       automaticEventMapping: {
         type: Boolean,
         default: false,
       },
       insertManualStreamId: {
         type: String,
         default: '',
       }, */
    },
    created() {
      if (!userLoggedIn() || !this.continousStreamingSis) {
        return;
      }

      this.executeProviderData();
    },
    methods: {
      changeProvider(providerId) {
        this.loading = true;

        getStreamingMatches(providerId).then((data) => {
          const { groupedTournaments, streamId } = data;

          this.hasTournaments = Object.keys(groupedTournaments).length > 0;
          this.streamId = streamId;
        }).catch(() => {
          this.streamId = '';
        }).finally(() => {
          this.loading = false;
        });
      },
      executeProviderData() {
        switch (true) {
          case this.continousStreamingSis:
            this.changeProvider(STREAM_PROVIDERS.SIS);
            break;
          /**  TODO:
           case this.automaticEventMapping:
             break;
           case this.insertManualStreamId:
             break;
          */
          default:
            break;
        }
      },
      livePlayerLoadError() {
        this.livePlayerFailed = true;
      },
      userLoggedIn,
    },
    components: {
      LivestreamComponent,
      EmptyState,
    },
  };
</script>
